import { Box } from '../../Box';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const ListItem = props => {
  const {
    children,
    className,
    id,
    onClick,
    ...rest
  } = props;
  return /*#__PURE__*/_jsx(Box, {
    id: id,
    component: "div",
    "data-testid": rest['data-testid'],
    className: clsx(['ids-list-item', className]),
    children: children
  });
};
ListItem.displayName = 'ListItem';